// Definição para o modal de busca de Perfis Tributários
// Utilizada no CampoBusca da Matriz Fiscal e outros componentes que precisam selecionar perfis

import { ST } from '@/constants/ST'

export const criarConfigBuscaPerfilTributario = (idOrganizacao) => ({
  label: 'Perfil Tributário',
  placeholder: 'ID do Perfil...',
  titulo: 'Selecionar Perfil Tributário',
  endpointApi: 'PerfisTributarios',
  idField: 'idPerfilTributario',
  descField: 'descricao',
  displayField: 'idPerfilTributario',
  tabela: 'PerfilTributario',
  camposFiltro: [
    { label: 'Descrição', model: 'busca', tipo: 'text' },
    { label: 'Natureza', model: 'lstNaturezaItemAtendido', tipo: 'text' },
    { label: 'Empresa', model: 'idOrganizacao', tipo: 'hidden', value: idOrganizacao }
  ],
  filtrosFixos: {
    lstStatus: ST.Ativo
  },
  colunasGrid: [
    { header: 'ID', dataField: 'idPerfilTributario', width: '8%' },
    { header: 'Descrição', dataField: 'descricao', width: '34%' },
    { header: 'Natureza', dataField: 'lstNaturezaItemAtendido', width: '17%' },
    { header: 'ICMS %', dataField: 'icmsAliquota', width: '10%' },
    { header: 'IPI %', dataField: 'ipiAliquota', width: '10%' },
    { header: 'PIS %', dataField: 'pisAliquota', width: '10%' },
    { header: 'COFINS %', dataField: 'cofinsAliquota', width: '11%' }
  ]
})
